import TaxonomyCard from '@/components/cards/taxonomy-card/taxonomy-card';
import { getComponent, toFibText } from '@/utils/question';
import { Vue, Component, Prop } from 'vue-property-decorator';
import FIB from '../fill-in-blank/fill-in-the-blank';
import FreeResponse from '../free-response/free-response';
import HotTextHighlight from '../hot-text-highlight/hot-text-highlight';
import HsImage from '../hs-image/hs-image';
import HsText from '../hs-text/hs-text';
import MultipleAnswer from '../multiple-answer/multiple-answer';
import MultipleChoice from '../multiple-choice/multiple-choice';
import ScientificFIB from '../scientific-fib/scientific-fib';
import ScientificFreeResponse from '../scientific-free-response/scientific-free-response';
import DecodingAssessment from '../serp-questions/decoding-assessment/decoding-assessment';
import EncodingAssessment from '../serp-questions/encoding-assessment/encoding-assessment';
import SayoutLoud from '../serp-questions/sayout-loud/sayout-loud';
import Underline from '../serp-questions/underline/underline';
import TrueFalse from '../true-false/true-false';
import { formatTime } from '@/utils/date';

@Component({
    name: 'question-viewer',
    components: {
        'multiple-answer': MultipleAnswer,
        'fib': FIB,
        'multiple-choice': MultipleChoice,
        'hs-text': HsText,
        'hs-image': HsImage,
        'true-false': TrueFalse,
        'hot-text-highlight': HotTextHighlight,
        'open-ended': FreeResponse,
        'scientific-fib': ScientificFIB,
        'scientific-free-response': ScientificFreeResponse,
        'encoding-assessment': EncodingAssessment,
        'decoding-assessment': DecodingAssessment,
        'say-out-loud': SayoutLoud,
        'identify-digraph': Underline,
        'taxonomy-tag': TaxonomyCard,
    },
})

export default class QuestionViewer extends Vue {

    // ------------------------------------------------------------------
    // Properties

    @Prop()
    private resourceResults: any;

    // ------------------------------------------------------------------
    // Methods

    private getComponent(type: string) {
        return getComponent(type);
    }

    private toFibText(text: string) {
        return toFibText(text);
    }

    private titleLoader(content: any) {
        const resource = content.resource;
        let text = resource ? (resource.text || resource.title) : '';
        if (content.questionType === 'FIB') {
            text = this.toFibText(text);
        }
        return text;
    }

    private formatTime(time: number) {
        return formatTime(time);
    }

}
